import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { useAction } from 'hooks';
import Form from 'components/Form';
import Button from 'components/Form/Button';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import App from 'modules/App';
import { RESET_PASSWORD_FORM } from '../../../constants';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import BackBtn from '../BackBtn';
import validatorRules from './validatorRules.json';
const EmailForm = ({ returnUrl })=>{
    const formValues = useSelector(App.selectors.formSelector(RESET_PASSWORD_FORM));
    const isInProgress = useSelector(selectors.isResetPasswordInProgress);
    const resetPassword = useAction(actions.resetPassword);
    const onSetValue = useAction(App.actions.setFormValue, RESET_PASSWORD_FORM);
    const submitForm = ({ email })=>{
        resetPassword(email);
    };
    const processForm = App.hooks.useFormProcessing(RESET_PASSWORD_FORM, submitForm);
    const isFormNotCompleted = App.hooks.useIsFormNotCompleted(formValues, validatorRules);
    const onSubmit = ()=>{
        processForm(formValues, validatorRules);
    };
    return /*#__PURE__*/ _jsxs(Form, {
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(FormGroup, {
                    id: "email",
                    labelMessage: messages.labels.email,
                    formValues: formValues,
                    children: /*#__PURE__*/ _jsx(Input, {
                        placeholder: messages.placeholders.email,
                        onChange: onSetValue
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row flex-column-reverse flex-sm-row",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-12 col-sm-6",
                        children: /*#__PURE__*/ _jsx(BackBtn, {
                            returnUrl: returnUrl,
                            asCancel: true
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-12 col-sm-6",
                        children: /*#__PURE__*/ _jsx(Button, {
                            type: "submit",
                            styleModifier: "primary",
                            labelMessage: App.messages.buttons.continue,
                            className: "btn--block btn--filled",
                            isDisabled: isFormNotCompleted,
                            isInProgress: isInProgress
                        })
                    })
                ]
            })
        ]
    });
};
export default EmailForm;
